import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const FileFilledIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 18 22"
        >
            <g className={fillStyles} fill="#000" fillRule="evenodd">
                <path d="M10 1.016 9.999.952a1.032 1.032 0 0 0-.952-.95L9 0H5.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392A4 4 0 0 0 .436 2.184C.189 2.669.09 3.186.044 3.748 0 4.29 0 4.954 0 5.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C4.29 22 4.954 22 5.758 22h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V9l-.001-.047A1.032 1.032 0 0 0 17.048 8L16.985 8h-4.417c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C10 5.93 10 5.684 10 5.432V1.016zM5 12a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H5zm0 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H5z" />
                <path
                    d="M15.908 6c.294 0 .44 0 .56-.074a.536.536 0 0 0 .226-.543c-.033-.137-.13-.233-.32-.424L13.04 1.627c-.191-.192-.287-.288-.424-.32a.536.536 0 0 0-.543.224c-.074.12-.074.267-.074.561V5.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C12.38 6 12.52 6 12.8 6h3.108z"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};
